import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { ApiKeyFormSchemaValues } from 'src/features/apiKeys/utils/formSchema';
import { ApiKey } from 'src/features/apiKeys/utils/types';

type MutationFnType = typeof mutationFn;

interface DTO {
    data: ApiKeyFormSchemaValues;
    keyId: string;
    parkingId: string;
}
const mutationFn = ({ keyId, parkingId, data }: DTO): Promise<ApiKey> => {
    return axios.put(`sp-core/${parkingId}/system/api-key/${keyId}/`, data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateApiKey };
